import React from "react"
import styled from "@emotion/styled"
import { AppContext } from '../../context'

import { HudIconButton } from "../molecules/hudButton"
import { IconType } from "../atoms/icon"
import { themeColor } from '../layout/global-style';
import { useMediaQuery } from "@react-hook/media-query"
import { useDebounce } from "use-debounce/lib"

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0;
    position: absolute;
    z-index: 1;
    pointer-events: none;
    left: 24px;
    right: 24px;
    top: 24px;
    
    svg{
        height: 24px;
    }

    @media screen and (max-width: 768px) {
        justify-content: space-between;
        svg {
            height: 18px;
        }
    }
`

export const CloseButton = ({ onClick, audio, color, hoverColor, isMobile }) => (
    <HudIconButton
        icon={IconType.close}
        onClick={onClick}
        audio={audio}
        color={color}
        fontColor={color}
        hoverColor={hoverColor}
        handleKeys={['esc']}
        frame = {isMobile}
    />
)

export default () => {
    const { audio, selection, setSelection, playingVideo, setPlayingVideo, tableOfContents, setTableOfContents, langSelection, setLangSelection } = React.useContext(AppContext);

    const onClick = React.useCallback(e => {
        e.stopPropagation();
        selection && setSelection(null);
        playingVideo && setPlayingVideo(null);
        tableOfContents && setTableOfContents(false);
        langSelection && setLangSelection(false);
    })

    const isMobile = useMediaQuery('only screen and (max-width: 768px)');
    const [hide] = useDebounce(!!(selection || playingVideo || tableOfContents || (langSelection && !isMobile)), 100);

    return hide ? (
        <Container>
            <CloseButton isMobile={isMobile} onClick={onClick} audio={audio} color={tableOfContents || langSelection ? themeColor.black : undefined} hoverColor={tableOfContents || langSelection ? themeColor.red : undefined} />
        </Container>
    ) : null;
}
